<div class="offer-sites-page">
  <app-prevention-group-header activeTab="offers"></app-prevention-group-header>
  <div class="breadcrumb-bar">
    <button class="breadcrumb-back" (click)="goBack()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
      {{ 'preventionOffres.offerSites.back' | translate }}
    </button>
    <span class="breadcrumb-sep">·</span>
    <a class="breadcrumb-link" routerLink="/pilotage-prevention">{{ 'preventionOffres.offerSites.breadcrumb.prevention' | translate }}</a>
    <span class="breadcrumb-sep">·</span>
    <a class="breadcrumb-link" routerLink="/prevention-offres">{{ 'preventionOffres.offerSites.breadcrumb.offers' | translate }}</a>
    <span class="breadcrumb-sep">·</span>
    <span class="breadcrumb-current">{{ offerDetail()?.name }}</span>
    <span class="breadcrumb-sep">·</span>
    <span class="breadcrumb-current">{{ 'preventionOffres.offerSites.breadcrumb.current' | translate }}</span>
  </div>

  @if (loadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.offerSites.loadError' | translate }}</div></div>
  } @else if (loading()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.offerSites.loading' | translate }}</div></div>
  } @else {
    @if (isArchived()) {
      <div class="card os-archived-banner">{{ 'preventionOffres.offerSites.archivedBanner' | translate }}</div>
    }

    <div class="card os-summary">
      <div class="ct">{{ offerDetail()!.name }}</div>
      <div class="cs">
        {{ (bilanCount() > 1 ? 'preventionOffres.offerSites.bilanCountPlural' : 'preventionOffres.offerSites.bilanCountSingular') | translate: { count: bilanCount() } }}
        · {{ activeSiteCountProjected() }}/{{ totalSiteCount() }} {{ 'preventionOffres.offerSites.activeSites' | translate }}
      </div>
    </div>

    <div class="card os-toolbar">
      <span class="os-search">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input
          class="os-search-input"
          type="text"
          [attr.aria-label]="'preventionOffres.offerSites.searchAriaLabel' | translate"
          [placeholder]="'preventionOffres.offerSites.searchPlaceholder' | translate"
          [value]="search()"
          (input)="onSearchChanged($any($event.target).value)">
      </span>

      <label class="os-select-all">
        <input type="checkbox" [checked]="allVisibleSelected()" (change)="toggleSelectAllVisible()" [disabled]="isArchived() || visibleRows().length === 0">
        {{ 'preventionOffres.offerSites.selectAll' | translate }}
      </label>

      <div class="os-common-price">
        <div class="toggle-label">{{ 'preventionOffres.offerSites.commonPrice' | translate }}</div>
        <div class="os-common-price-row">
          <input
            class="input os-common-price-input"
            type="number"
            min="0"
            step="0.01"
            [attr.aria-label]="'preventionOffres.offerSites.commonPrice' | translate"
            [value]="commonPriceDraft() ?? ''"
            [disabled]="isArchived()"
            (input)="onCommonPriceInput($any($event.target).value)">
          <select
            class="select-ctrl"
            [attr.aria-label]="'preventionOffres.offerSites.currency' | translate"
            [value]="commonPriceCurrency()"
            [disabled]="isArchived()"
            (change)="onCommonPriceCurrencyChanged($any($event.target).value)">
            @for (c of currencies; track c) {
              <option [value]="c">{{ c }}</option>
            }
          </select>
          <button class="btn-ps-sm" [disabled]="!canApplyCommonPrice()" (click)="applyCommonPrice()">
            {{ 'preventionOffres.offerSites.applyCommonPrice' | translate }}
          </button>
        </div>
      </div>
    </div>

    @if (visibleRows().length === 0) {
      <div class="card"><div class="cs" style="text-align:center;padding:20px 0">{{ 'preventionOffres.offerSites.noResult' | translate }}</div></div>
    } @else {
      @for (row of visibleRows(); track row.establishmentId) {
        <div class="card os-site-row" [class.os-site-row-invalid]="isInvalid(row.establishmentId)">
          <div class="os-site-summary">
            <input type="checkbox"
                   [attr.aria-label]="('preventionOffres.offerSites.selectSite' | translate) + ' ' + row.establishmentName"
                   [checked]="isSelected(row.establishmentId)"
                   [disabled]="isArchived()"
                   (change)="toggleSelect(row.establishmentId)">

            <button type="button" class="os-toggle-btn"
                    [attr.aria-pressed]="row.active"
                    [attr.aria-label]="('preventionOffres.offerSites.toggleActive' | translate) + ' ' + row.establishmentName"
                    [disabled]="isArchived()"
                    (click)="onToggleActive(row.establishmentId)">
              <div [class]="row.active ? 'toggle-on' : 'toggle-off'"></div>
            </button>

            <div class="os-site-name">{{ row.establishmentName }}</div>

            @if (row.active) {
              <input class="input os-price-input"
                     type="number"
                     min="0"
                     step="0.01"
                     [attr.aria-label]="('preventionOffres.offerSites.price' | translate) + ' ' + row.establishmentName"
                     [attr.aria-describedby]="isInvalid(row.establishmentId) ? 'os-price-error-' + row.establishmentId : null"
                     [value]="row.price ?? ''"
                     [disabled]="isArchived()"
                     (input)="onPriceInput(row.establishmentId, $any($event.target).value)">
              <select class="select-ctrl"
                      [attr.aria-label]="'preventionOffres.offerSites.currency' | translate"
                      [value]="row.currency"
                      [disabled]="isArchived()"
                      (change)="onCurrencyChanged(row.establishmentId, $any($event.target).value)">
                @for (c of currencies; track c) {
                  <option [value]="c">{{ c }}</option>
                }
              </select>
            } @else {
              <div class="cs os-no-price">{{ formatPrice(row) }}</div>
            }

            <button type="button" class="btn-secondary-sm"
                    [attr.aria-expanded]="isExpanded(row.establishmentId)"
                    [attr.aria-controls]="'os-config-' + row.establishmentId"
                    [disabled]="isArchived()"
                    (click)="toggleExpand(row.establishmentId)">
              {{ 'preventionOffres.offerSites.configure' | translate }}
            </button>
          </div>

          @if (isInvalid(row.establishmentId)) {
            <div class="of-error" [id]="'os-price-error-' + row.establishmentId">{{ 'preventionOffres.offerSites.priceRequired' | translate }}</div>
          }

          @if (isExpanded(row.establishmentId)) {
            <div class="os-advanced" [id]="'os-config-' + row.establishmentId">
              <label class="toggle-label" [for]="'os-conditions-' + row.establishmentId" style="display:block;margin-bottom:4px">{{ 'preventionOffres.offerSites.conditions' | translate }}</label>
              <textarea [id]="'os-conditions-' + row.establishmentId"
                        class="textarea-ctrl"
                        rows="2"
                        [value]="row.conditions ?? ''"
                        [disabled]="isArchived()"
                        [placeholder]="'preventionOffres.offerSites.conditionsPlaceholder' | translate"
                        (input)="onConditionsChanged(row.establishmentId, $any($event.target).value)"></textarea>
              <div class="cs" style="margin-top:4px">{{ 'preventionOffres.offerSites.conditionsHelp' | translate }}</div>

              <label class="toggle-label" [for]="'os-feasibility-' + row.establishmentId" style="display:block;margin-bottom:4px">{{ 'preventionOffres.offerSites.immediateFeasibility' | translate }}</label>
              <select [id]="'os-feasibility-' + row.establishmentId"
                      class="select-ctrl"
                      [value]="row.immediateFeasibilityDefault === null ? '' : (row.immediateFeasibilityDefault ? 'true' : 'false')"
                      [disabled]="isArchived()"
                      (change)="onFeasibilityChanged(row.establishmentId, $any($event.target).value)">
                <option value="">{{ groupFeasibilityOptionLabel() }}</option>
                <option value="true">{{ 'preventionOffres.offerSites.feasibilityOptionImmediate' | translate }}</option>
                <option value="false">{{ 'preventionOffres.offerSites.feasibilityOptionLater' | translate }}</option>
              </select>
              <div class="cs" style="margin-top:4px">{{ 'preventionOffres.offerSites.immediateFeasibilitySub' | translate }}</div>

              <label class="toggle-label" [for]="'os-contact-' + row.establishmentId" style="display:block;margin:10px 0 4px">{{ 'preventionOffres.offerSites.contactRole' | translate }}</label>
              <select [id]="'os-contact-' + row.establishmentId"
                      class="select-ctrl"
                      [value]="row.patientContactRole ?? ''"
                      [disabled]="isArchived()"
                      (change)="onContactRoleChanged(row.establishmentId, $any($event.target).value)">
                <option value="">{{ 'preventionOffres.offerSites.contactRoleDefaultOption' | translate }}</option>
                <option value="ACCUEIL">{{ 'preventionOffres.offerSites.contactRoles.ACCUEIL' | translate }}</option>
                <option value="PRELEVEUR">{{ 'preventionOffres.offerSites.contactRoles.PRELEVEUR' | translate }}</option>
                <option value="BIOLOGISTE">{{ 'preventionOffres.offerSites.contactRoles.BIOLOGISTE' | translate }}</option>
                <option value="AUTRE">{{ 'preventionOffres.offerSites.contactRoles.AUTRE' | translate }}</option>
              </select>

              @if (row.hasDuplicateCoverage) {
                <button type="button" class="toggle-row-item os-commercial-preference-toggle"
                        style="margin-top:10px"
                        [attr.aria-pressed]="row.commercialPreference"
                        [disabled]="isArchived()"
                        (click)="onToggleCommercialPreference(row.establishmentId)">
                  <div>
                    <div class="toggle-label">{{ 'preventionOffres.offerSites.commercialPreference' | translate }}</div>
                    <div class="toggle-sub">{{ 'preventionOffres.offerSites.commercialPreferenceSub' | translate }}</div>
                  </div>
                  <div [class]="row.commercialPreference ? 'toggle-on' : 'toggle-off'"></div>
                </button>
              }
            </div>
          }
        </div>
      }
    }

    <div class="os-save-bar">
      <button class="btn-ps-sm" [disabled]="!canSave()" (click)="save()">
        {{ (saving() ? 'preventionOffres.offerSites.saving' : 'preventionOffres.offerSites.save') | translate }}
      </button>
    </div>
  }
</div>

@if (showLeaveConfirm()) {
  <app-confirm-modal
    [title]="'preventionOffres.offerForm.unsavedChanges.title' | translate"
    [message]="'preventionOffres.offerForm.unsavedChanges.message' | translate"
    [confirmText]="'preventionOffres.offerForm.unsavedChanges.confirmButton' | translate"
    [cancelText]="'preventionOffres.offerForm.unsavedChanges.cancelButton' | translate"
    (confirm)="confirmLeaveNavigation()"
    (cancel)="cancelLeaveNavigation()">
  </app-confirm-modal>
}
